/* eslint-disable */
import {gsap} from "gsap";

window.addEventListener('load', () => {
  HeroHome.init();
});

const HeroHome = {
  init: function () {
    const sections = document.querySelectorAll('[data-hero-home-block-js]');

    if (!sections.length) return;

    sections.forEach((section) => {
      this.initSection(section)
    })

  },

  initSection: function(section) {
    const html = document.documentElement;
    const canvas = document.querySelector('[data-deco-canvas-js]');
    const decoElWrap = document.querySelector('[data-deco-wrap-js]');
    const context = canvas.getContext("2d");
    const imgDir = canvas.getAttribute('data-deco-img-dir-js');

    const frameCount = 70;
    const currentFrame = index => (
      `${imgDir}${index.toString().padStart(4, '0')}.jpg`
    )

    const preloadImages = () => {
      for (let i = 1; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);}
    };

    const img = new Image()
    img.src = currentFrame(1);
    canvas.width=1200;
    canvas.height=980;
    img.onload=function(){
      context.drawImage(img, 0, 0);
    }

    const updateImage = index => {
      img.src = currentFrame(index);
      context.drawImage(img, 0, 0);
    }

    let logoTurnTl = gsap.timeline({
      immediateRender: false,

      scrollTrigger: {
        trigger: html,
        endTrigger: decoElWrap,
        start: 'top top',
        end: 'bottom top',
        scrub: 0,
        // markers: true,
        onUpdate: self => {
          let frameIndex = Math.round(frameCount*self.progress)
          requestAnimationFrame(() => updateImage(frameIndex + 1))
        },
      }
    });

    preloadImages();
  },

}

export default HeroHome;
